<script lang="ts">
  import { push } from "svelte-spa-router";
  import { auth } from "../../stores";

  async function signIn() {
    await auth.signIn();
    await push("/app");
  }
</script>

<div class="row row-cols-1 row-cols-md-3 mb-3 text-center">
  <div class="col" />
  <div class="col">
    <div class="card mb-4 rounded-3 shadow-sm">
      <div class="card-header py-3">
        <h4 class="my-0 fw-normal">Beta</h4>
      </div>
      <div class="card-body">
        <h1 class="card-title pricing-card-title">
          $0<small class="text-muted fw-light">/mo</small>
        </h1>
        <ul class="list-unstyled mt-3 mb-4">
          <li>Unlimited private project</li>
          <li>Unlimited public projects</li>
          <li>Email support</li>
        </ul>
        <button
          type="button"
          class="w-100 btn btn-lg btn-outline-success"
          on:click={signIn}>Sign up for free</button
        >
      </div>
    </div>
  </div>

  <div class="col" />
</div>

<style>
  h1 {
    font-family: Montserrat;
    font-style: normal;
    font-size: 52px;
    line-height: 76px;
    font-weight: bold;
    text-transform: capitalize;
    color: #2f2e34;
  }

  h4 {
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
  }
</style>
